import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const FooterContainer = styled.footer`
  background-color: var(--bg-secondary);
  border-top: 1px solid var(--border-color);
  padding: 2.5rem 0 1rem;
`;

export const FooterContent = styled.div`
  max-width: var(--container-max);
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr;
  gap: 2rem;
  padding: 0 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const FooterSection = styled.div`
  p {
    color: var(--text-muted);
    font-size: 0.85rem;
    line-height: 1.6;
    margin: 0;
  }
`;

export const FooterTitle = styled.h3`
  font-family: var(--font-heading);
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--text-primary);
  margin-bottom: 1rem;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -6px;
    width: 30px;
    height: 2px;
    background: var(--gradient-accent);
    border-radius: 1px;
  }
`;

export const QuickLinksGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.1rem 1.5rem;
`;

export const FooterLink = styled(Link)`
  display: block;
  color: var(--text-muted);
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
  transition: all var(--transition-fast);

  &:hover {
    color: var(--accent-teal);
    padding-left: 4px;
  }
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.6rem;
  color: var(--text-muted);
  font-size: 0.85rem;
`;

export const ContactIcon = styled.div`
  margin-right: 0.6rem;
  color: var(--accent-teal);
  flex-shrink: 0;
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 0.6rem;
  margin-top: 1rem;
`;

export const SocialIcon = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background-color: var(--bg-card);
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  transition: all var(--transition-base);

  &:hover {
    background-color: var(--accent-teal);
    border-color: var(--accent-teal);
    color: var(--bg-primary);
    transform: translateY(-2px);
    box-shadow: var(--shadow-glow-teal);
  }
`;

export const Copyright = styled.div`
  text-align: center;
  padding-top: 1.2rem;
  margin-top: 1.5rem;
  border-top: 1px solid var(--border-color);
  color: var(--text-muted);
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  max-width: var(--container-max);
  margin-left: auto;
  margin-right: auto;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
`;
